// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 70px;
  height: 70px;
  background-color: #3289c9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: transform 0.3s ease, background-color 0.3s ease;
  z-index: 1000;
  border: 2px solid #ffffff;
}

.voice-button:hover {
  background-color: #25679a;
  transform: scale(1.1);
}

/* Overlay del modal */
.voice-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Contenedor principal */
.voice-modal-content {
  background-color: #1f2937;
  color: #f1f5f9;
  padding: 24px;
  border-radius: 16px;
  width: 90%;
  max-width: 440px;
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: fadeIn 0.3s ease-in-out;
  position: relative;
}

/* Header del modal */
.voice-modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.voice-close-button {
  background: none;
  border: none;
  font-size: 22px;
  color: #94a3b8;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.voice-close-button:hover {
  color: #f1f5f9;
}

/* Cuerpo del modal */
.voice-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.voice-instruction {
  font-size: 14px;
  color: #cbd5e1;
  text-align: center;
  line-height: 1.5;
}

/* Botón micrófono */
.voice-mic-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3289c9;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.voice-mic-button:hover {
  transform: scale(1.1);
}

/* Estados del botón */
.voice-mic-button.listening {
  background-color: #ef4444;
}

.voice-mic-button.waiting {
  background-color: #f59e0b;
}

.voice-mic-button.bot-speaking {
  background-color: #475569;
}

.voice-mic-button.not-listening {
  background-color: #3289c9;
}

/* Icono mic */
.icon-mic {
  font-size: 30px;
}

/* Botón para detener voz */
.voice-stop-speech-button {
  color: #ef4444;
  padding: 10px 18px;
  border: none;
  border-radius: 10px;
  background-color: transparent;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.voice-stop-speech-button:hover {
  color: #dc2626;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatBar/ModalVoice/VoiceChatModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,eAAe;EACf,2DAA2D;EAC3D,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".voice-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 70px;\n  height: 70px;\n  background-color: #3289c9;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  z-index: 1000;\n  border: 2px solid #ffffff;\n}\n\n.voice-button:hover {\n  background-color: #25679a;\n  transform: scale(1.1);\n}\n\n/* Overlay del modal */\n.voice-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(6px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Contenedor principal */\n.voice-modal-content {\n  background-color: #1f2937;\n  color: #f1f5f9;\n  padding: 24px;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 440px;\n  box-shadow: 0 0 24px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: fadeIn 0.3s ease-in-out;\n  position: relative;\n}\n\n/* Header del modal */\n.voice-modal-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.voice-close-button {\n  background: none;\n  border: none;\n  font-size: 22px;\n  color: #94a3b8;\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.voice-close-button:hover {\n  color: #f1f5f9;\n}\n\n/* Cuerpo del modal */\n.voice-modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.voice-instruction {\n  font-size: 14px;\n  color: #cbd5e1;\n  text-align: center;\n  line-height: 1.5;\n}\n\n/* Botón micrófono */\n.voice-mic-button {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3289c9;\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.voice-mic-button:hover {\n  transform: scale(1.1);\n}\n\n/* Estados del botón */\n.voice-mic-button.listening {\n  background-color: #ef4444;\n}\n\n.voice-mic-button.waiting {\n  background-color: #f59e0b;\n}\n\n.voice-mic-button.bot-speaking {\n  background-color: #475569;\n}\n\n.voice-mic-button.not-listening {\n  background-color: #3289c9;\n}\n\n/* Icono mic */\n.icon-mic {\n  font-size: 30px;\n}\n\n/* Botón para detener voz */\n.voice-stop-speech-button {\n  color: #ef4444;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 10px;\n  background-color: transparent;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.voice-stop-speech-button:hover {\n  color: #dc2626;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
